import BaseModel from '../base/BaseModel.model';
//import AcademicTitle from '../academic/academicTitle.model';
export default class MasterEducation extends BaseModel {
    public userId?: number;
    public countryId?: number;
    public institutionName?:string;
    public curriculumUserId?: number;
    public starYear?: Date | any;
    public endYear?:  Date | any;
    public title?:  string;
    public place?: string;
    public academicTitleId?: number;
    //public academicTitle?: AcademicTitle;

    constructor(){
        super();
        this.init();
    }

    init(){ 
        this.institutionName = "";
        this.userId = undefined;
        this.countryId = undefined;
        this.curriculumUserId = undefined;
        this.title = "";
        this.place = "";   
        this.academicTitleId = undefined;
        //this.academicTitle = new AcademicTitle();
    }
}